// src/Pages/Home.js
import React from "react";
import Navigation from "../Components/Navigation";
import Hero from "../Components/Hero";
import ProductList from "../Components/ProductList";
import AboutUs from "../Components/AboutUs";
import ContactUs from "../Components/ContactUs";
import Footer from "../Components/Footer";
import Services from "../Components/Services";

function Home() {
  return (
    <>
      <Navigation />
      <Hero />
      <ProductList />
      <Services />
      <AboutUs />
      <ContactUs /> 
      <Footer />
    </>
  );
}

export default Home;
